import {
  getAdditionalFilters,
  isHavingMarketInRules,
} from '@/hooks/useInvestingIdeaScreener/utils';
import { parseRules } from '@/pages/Screener/functions';
import { usePredefinedScreenersQuery } from './usePredefinedScreenersQuery';
import { useMemo } from 'react';

type Params = {
  rawRules: string;
  market: string;
  industry: string;
  gridViewId: string;
  initPage: number;
  pageSize: number;
  isInfinite: boolean;
  returnRecentCompaniesOnly: boolean;
};

export const useInvestingIdeaScreener = ({
  rawRules,
  market,
  industry,
  gridViewId,
  initPage,
  pageSize,
  isInfinite,
  returnRecentCompaniesOnly,
}: Params) => {
  const isMarketInRules = useMemo(() => {
    const parsedRules = parseRules(rawRules);
    return isHavingMarketInRules(parsedRules);
  }, [rawRules]);

  const additionalFilters = useMemo(() => {
    return getAdditionalFilters({
      market,
      industry,
      isMarketInRules,
    });
  }, [industry, isMarketInRules, market]);

  const {
    companies,
    totalRecords,
    newCompaniesCount,
    totalPages,
    fetchNextPage,
    hasNextPage,
    isFetching: isFetchingCompanies,
    isFetched,
    systemRestrictions,
    status,
  } = usePredefinedScreenersQuery({
    gridViewId: parseFloat(gridViewId),
    initPage,
    pageSize,
    isInfinite,
    additionalFilters,
    returnRecentCompaniesOnly,
  });

  return {
    companies,
    totalRecords,
    newCompaniesCount,
    totalPages,
    fetchNextPage,
    hasNextPage,
    isFetchingCompanies,
    isFetched,
    systemRestrictions,
    isMarketInRules,
    status,
  };
};
